var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnicalImprovement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M24.3 22.3c-7.6-2.2-7.6 5.8-2.8 5.7 4.7-.1 5.3 7.5-3.1 5.2M21.3 20.6v.7M21.3 34.2v.7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 31.7,
    cy: 40.3,
    r: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M31.7 35V24.3h6.8L21.4 9.2 4.6 24.6h6.9v16.1h14.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M3.7 18.9l17.9-17 16.9 15.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicalImprovement);
export default __webpack_public_path__ + "static/media/technicalImprovement.2d1b8bcaba39ddb13a3ca528a9eb766c.svg";
export { ForwardRef as ReactComponent };